import { Box, Button, Container, Icon, Stack } from "@chakra-ui/react"
import { FulfillmentTypes } from "@jackfruit/common"
import React from "react"
import { IoStorefrontOutline } from "react-icons/io5"
import { MdCheckCircle } from "react-icons/md"
import { PiPackageLight } from "react-icons/pi"
import { WHITE } from "../blocks/FulfillmentBlockDarkBlack"
import { FulfillmentConfig } from "./CardButtonWrapperV2"

interface props {
  config: FulfillmentConfig
  fulfillmentType: FulfillmentTypes
  isSelected: boolean
  onSetChoice: (fulfillment: FulfillmentTypes) => void
  isDisabled?: boolean
}

const BUTTON_ACTIVE_COLOR_MOBILE = "#272727"

const CardButtonMobileV2: React.FC<props> = ({
  config,
  fulfillmentType,
  isSelected,
  onSetChoice,
  isDisabled = false,
}) => {
  const { title, icon } = config
  const showDefaultPickupIcon = !icon && fulfillmentType === "pickup"
  const showDefaultDeliveryIcon = !icon && fulfillmentType === "delivery"

  return (
    <Button
      id={`p-fulfillment-${fulfillmentType}-mobile`}
      px={2}
      py={4}
      h="auto"
      w="full"
      variant="ghost"
      borderRadius="lg"
      display={{ base: "relative", md: "none" }}
      whiteSpace="normal"
      onClick={() => onSetChoice(fulfillmentType)}
      isDisabled={isDisabled}
      bg={isSelected ? BUTTON_ACTIVE_COLOR_MOBILE : "transparent"}
      _hover={{ bg: BUTTON_ACTIVE_COLOR_MOBILE }}
      border={`1px solid ${isSelected ? WHITE : "#4A5568"}`}
    >
      <Box position="absolute" top={2} right={2}>
        {isSelected && (
          <Icon
            boxSize={8}
            as={MdCheckCircle}
            color={WHITE}
            borderRadius="full"
          />
        )}
      </Box>
      <Stack direction="column" minH={28} spacing={3} justify="center">
        <Container>
          {icon && <Box dangerouslySetInnerHTML={{ __html: icon }} />}
          {showDefaultPickupIcon && (
            <Icon as={IoStorefrontOutline} color={WHITE} boxSize={10} />
          )}
          {showDefaultDeliveryIcon && (
            <Icon as={PiPackageLight} color={WHITE} boxSize={10} />
          )}
        </Container>
        <Container as="h4" px={3} fontSize="lg" color={WHITE}>
          {title}
        </Container>
      </Stack>
    </Button>
  )
}

export default CardButtonMobileV2
